import { z } from "zod";

const DataSchema = z.object({
    created_at: z.string(),
    display_name: z.string(),
    guard_name: z.string(),
    id: z.number(),
    name: z.string(),
    property_id: z.nullable(z.string()),
    updated_at: z.string(),
});

export const AssignResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    data: DataSchema,
});